import { render } from "./AnswersFromTicketComponent.vue?vue&type=template&id=02038cdf&scoped=true"
import script from "./AnswersFromTicketComponent.vue?vue&type=script&lang=js"
export * from "./AnswersFromTicketComponent.vue?vue&type=script&lang=js"

import "./AnswersFromTicketComponent.vue?vue&type=style&index=0&id=02038cdf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02038cdf"]])

export default __exports__